import React from 'react';
import { ReactComponent as RectangleLight } from '../../../../assets/img/figure/rectangleLight.svg';
import { ReactComponent as RectangleDark } from '../../../../assets/img/figure/rectangleDark.svg';
import { COLORS } from '../../../../store/colors';
import { FigureProps, FigureVariant } from './types';

const ASPECT_RATIO = 1.24;

export const FigureRectangle: React.FC<FigureProps> = ({
  className,
  variant = FigureVariant.dark,
  size = 100,
  unit = 'px',
  color,
  style
}) => {
  const figureStyle = {
    width: size !== 'auto' ? size + unit : undefined,
    height: size !== 'auto' ? size * ASPECT_RATIO + unit : undefined,
    color: color || COLORS.colorAccent100,
    ...style
  };

  if (color || variant === FigureVariant.light) {
    return <RectangleLight className={className} style={figureStyle} />;
  }
  return <RectangleDark className={className} style={figureStyle} />;
};
